import {ADMLoginResult} from '../../response/admin/admloginresult';
import {BaseResponse} from '../../response/internal/baseresponse';
import {LoginResult} from '../../response/loginresult';
import {LogoutResult} from '../../response/logoutresult';
import {Login} from '../../view-model/common/login';

import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {Http, Headers, RequestOptions} from '@angular/http';

import {Api} from '../config/api';
import {Base64Service} from './base64.service';
import {CryptoService} from './crypto.service';
import {RequestService} from './request.service';
import {SessionService} from './session.service';

@Injectable()
export class UserService {

  _options: RequestOptions;
  constructor(
    private http: Http,
    private request: RequestService,
    private cryptoService: CryptoService,
    public sessionService: SessionService,
    public base64Service: Base64Service) {
    this.initService();
  }

  private initService() {
    // http header;
    const header = new Headers();

    header.set('Accept', 'application/qsremit-encoded-form');
    header.set('Content-Type', 'application/qsremit-encoded-form');

    // http request option
    const option = new RequestOptions();
    option.headers = header;

    this._options = option;
  }

  /**
   * 로그아웃 요청
   * @return 로그아웃 결과
   */
  public logout(): Observable<LogoutResult> {
    delete this.request.enc_pad;
    return this.request.getBasic(Api.Agent.Logout, this._options, LogoutResult);
  }

  private _errorHandle(res: Response) {
    delete this.request.enc_pad;
    return Observable.throw(res);
  }

  /**
   * 어드민 로그인 요청
   */
  public adminLogin(loginInfo: Login): Observable<ADMLoginResult> {
    return this.request.postBasic(Api.Admin.Login, this._options, loginInfo, ADMLoginResult);
  }

  public adminLogout(): Observable<BaseResponse> {
    delete this.request.enc_pad;
    return this.request.getBasic(Api.Admin.Logout, this._options, LogoutResult);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/service/user.service.ts